export const reports = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',
  NavSidebar: {},
  TabInit: { display: 'none', show: (() => { let d = false; return (el, s) => { if (!d) { d = true; Promise.resolve().then(() => s.root.update({ activeTab: 'reports', reportType: s.root.reportType || 'production' })) } return false } })() },

  MainContent: {
    flow: 'y',
    flex: '1',
    overflow: 'auto',

    TopBar: {},

    ContentArea: {
      flow: 'y',
      gap: 'B',
      padding: 'B',
      flex: '1',
      '@mobileL': { padding: 'A' },

      PageTitle: { tag: 'h2', text: '{{ reportsAnalytics | polyglot }}', fontSize: 'C', fontWeight: '700', color: 'inkText', letterSpacing: '-0.02em' },

      // ─── REPORT TYPE NAV ─────────────────────────
      ReportTypeNav: {
        flow: 'x',
        gap: 'Z',
        borderBottom: '1px solid inkBorder',
        paddingBottom: 'Y',
        flexWrap: 'wrap',
        TabProduction: {
          text: '{{ production | polyglot }}',
          fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer',
          color: (el, s) => s.root.reportType === 'production' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => s.root.reportType === 'production' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ reportType: 'production' })
        },
        TabCollections: {
          text: '{{ collections | polyglot }}',
          fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer',
          color: (el, s) => s.root.reportType === 'collections' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => s.root.reportType === 'collections' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ reportType: 'collections' })
        },
        TabScheduling: {
          text: '{{ schedulingReport | polyglot }}',
          fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer',
          color: (el, s) => s.root.reportType === 'scheduling' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => s.root.reportType === 'scheduling' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ reportType: 'scheduling' })
        },
        TabAcceptance: {
          text: '{{ treatmentAcceptance | polyglot }}',
          fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer',
          color: (el, s) => s.root.reportType === 'acceptance' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => s.root.reportType === 'acceptance' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ reportType: 'acceptance' })
        },
        TabRecall: {
          text: '{{ recall | polyglot }}',
          fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer',
          color: (el, s) => s.root.reportType === 'recall' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => s.root.reportType === 'recall' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ reportType: 'recall' })
        }
      },

      // ─── PRODUCTION VIEW ─────────────────────────
      ProductionView: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.reportType === 'production',

        ProductionStatsRow: {
          flow: 'x', gap: 'A', flexWrap: 'wrap', '@mobileL': { flow: 'y' },
          CardGross: { extends: 'ReportCard', state: { title: 'Gross Production', value: '₾48,200', trend: '+12%', trendColor: 'green' } },
          CardNet: { extends: 'ReportCard', state: { title: 'Net Production', value: '₾42,100', trend: '+9%', trendColor: 'green' } },
          CardCollections: { extends: 'ReportCard', state: { title: 'Collections', value: '₾38,900', trend: '+7%', trendColor: 'green' } },
          CardRate: { extends: 'ReportCard', state: { title: 'Collection Rate', value: '92.4%', trend: '+2.1%', trendColor: 'green' } }
        },

        ProviderSection: {
          flow: 'y', gap: 'A', padding: 'B', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
          ProviderTitle: { tag: 'h3', text: '{{ productionByProvider | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText', marginBottom: 'Z' },
          ProviderDrK: { extends: 'ProductionReport', state: { provider: 'Dr. Kvaratskhelia', amount: '₾28,000', percentage: 58 } },
          ProviderDrB: { extends: 'ProductionReport', state: { provider: 'Dr. Beridze', amount: '₾14,200', percentage: 29 } },
          ProviderHygN: { extends: 'ProductionReport', state: { provider: 'Hyg. Nino', amount: '₾6,000', percentage: 13 } }
        },

        CategorySection: {
          flow: 'y', gap: 'A', padding: 'B', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
          CategoryTitle: { tag: 'h3', text: '{{ productionByCategory | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText', marginBottom: 'Z' },

          CategoryBars: {
            flow: 'y', gap: 'Z',

            BarPreventive: {
              flow: 'y', gap: 'X',
              BarLabel: { flow: 'x', align: 'center space-between', LabelText: { text: '{{ preventive2 | polyglot }}', fontSize: 'Z', color: 'inkSubtle' }, LabelPct: { text: '18%', fontSize: 'Z', color: 'inkMuted', fontWeight: '600' } },
              BarTrack: { height: 'Y', round: 'Y', background: 'inkSurface', overflow: 'hidden', BarFill: { width: '18%', height: '100%', background: 'teal', round: 'Y' } }
            },
            BarRestorative: {
              flow: 'y', gap: 'X',
              BarLabel: { flow: 'x', align: 'center space-between', LabelText: { text: '{{ restorative | polyglot }}', fontSize: 'Z', color: 'inkSubtle' }, LabelPct: { text: '34%', fontSize: 'Z', color: 'inkMuted', fontWeight: '600' } },
              BarTrack: { height: 'Y', round: 'Y', background: 'inkSurface', overflow: 'hidden', BarFill: { width: '34%', height: '100%', background: 'blue', round: 'Y' } }
            },
            BarEndo: {
              flow: 'y', gap: 'X',
              BarLabel: { flow: 'x', align: 'center space-between', LabelText: { text: '{{ endodontics | polyglot }}', fontSize: 'Z', color: 'inkSubtle' }, LabelPct: { text: '12%', fontSize: 'Z', color: 'inkMuted', fontWeight: '600' } },
              BarTrack: { height: 'Y', round: 'Y', background: 'inkSurface', overflow: 'hidden', BarFill: { width: '12%', height: '100%', background: 'amber', round: 'Y' } }
            },
            BarPerio: {
              flow: 'y', gap: 'X',
              BarLabel: { flow: 'x', align: 'center space-between', LabelText: { text: '{{ periodontics | polyglot }}', fontSize: 'Z', color: 'inkSubtle' }, LabelPct: { text: '15%', fontSize: 'Z', color: 'inkMuted', fontWeight: '600' } },
              BarTrack: { height: 'Y', round: 'Y', background: 'inkSurface', overflow: 'hidden', BarFill: { width: '15%', height: '100%', background: 'purple', round: 'Y' } }
            },
            BarProsth: {
              flow: 'y', gap: 'X',
              BarLabel: { flow: 'x', align: 'center space-between', LabelText: { text: '{{ prosthodontics | polyglot }}', fontSize: 'Z', color: 'inkSubtle' }, LabelPct: { text: '16%', fontSize: 'Z', color: 'inkMuted', fontWeight: '600' } },
              BarTrack: { height: 'Y', round: 'Y', background: 'inkSurface', overflow: 'hidden', BarFill: { width: '16%', height: '100%', background: 'gold', round: 'Y' } }
            },
            BarSurgery: {
              flow: 'y', gap: 'X',
              BarLabel: { flow: 'x', align: 'center space-between', LabelText: { text: '{{ surgery | polyglot }}', fontSize: 'Z', color: 'inkSubtle' }, LabelPct: { text: '5%', fontSize: 'Z', color: 'inkMuted', fontWeight: '600' } },
              BarTrack: { height: 'Y', round: 'Y', background: 'inkSurface', overflow: 'hidden', BarFill: { width: '5%', height: '100%', background: 'red', round: 'Y' } }
            }
          }
        }
      },

      // ─── COLLECTIONS VIEW ────────────────────────
      CollectionsView: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.reportType === 'collections',

        CollectionsStats: {
          flow: 'x', gap: 'A', flexWrap: 'wrap', '@mobileL': { flow: 'y' },
          CardTotal: { extends: 'ReportCard', state: { title: 'Total Collected', value: '₾38,900', trend: '+7%', trendColor: 'green' } },
          CardOutstanding: { extends: 'ReportCard', state: { title: 'Outstanding', value: '₾5,300', trend: '-3%', trendColor: 'green' } },
          CardInsurance: { extends: 'ReportCard', state: { title: 'Insurance Pending', value: '₾3,200', trend: '+1%', trendColor: 'amber' } },
          CardWriteOff: { extends: 'ReportCard', state: { title: 'Write-offs', value: '₾890', trend: '-12%', trendColor: 'green' } }
        },

        AgingReport: {
          flow: 'y', gap: 'Z', padding: 'B', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
          AgingTitle: { tag: 'h3', text: '{{ agingReport | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText', marginBottom: 'Z' },
          Age0to30: { flow: 'x', align: 'center space-between', padding: 'Z 0', borderBottom: '1px solid inkBorder', Label: { text: '0-30 days', fontSize: 'Z', color: 'inkSubtle' }, Value: { text: '₾2,100', fontSize: 'Z', fontWeight: '600', color: 'green' } },
          Age31to60: { flow: 'x', align: 'center space-between', padding: 'Z 0', borderBottom: '1px solid inkBorder', Label: { text: '31-60 days', fontSize: 'Z', color: 'inkSubtle' }, Value: { text: '₾1,400', fontSize: 'Z', fontWeight: '600', color: 'amber' } },
          Age61to90: { flow: 'x', align: 'center space-between', padding: 'Z 0', borderBottom: '1px solid inkBorder', Label: { text: '61-90 days', fontSize: 'Z', color: 'inkSubtle' }, Value: { text: '₾980', fontSize: 'Z', fontWeight: '600', color: 'amber' } },
          Age90Plus: { flow: 'x', align: 'center space-between', padding: 'Z 0', Label: { text: '90+ days', fontSize: 'Z', color: 'inkSubtle' }, Value: { text: '₾820', fontSize: 'Z', fontWeight: '600', color: 'red' } }
        }
      },

      // ─── SCHEDULING VIEW ─────────────────────────
      SchedulingView: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.reportType === 'scheduling',

        SchedulingStats: {
          flow: 'x', gap: 'A', flexWrap: 'wrap', '@mobileL': { flow: 'y' },
          CardUtil: { extends: 'ReportCard', state: { title: 'Chair Utilization', value: '78%', trend: '+5%', trendColor: 'green' } },
          CardNoShow: { extends: 'ReportCard', state: { title: 'No-show Rate', value: '4.2%', trend: '-1.8%', trendColor: 'green' } },
          CardAvgWait: { extends: 'ReportCard', state: { title: 'Avg Wait Time', value: '8 min', trend: '-2 min', trendColor: 'green' } },
          CardAppts: { extends: 'ReportCard', state: { title: 'Total Appointments', value: '342', trend: '+18', trendColor: 'green' } }
        },

        ScheduleByDay: {
          flow: 'y', gap: 'Z', padding: 'B', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
          DayTitle: { tag: 'h3', text: '{{ appointmentsByDay | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText', marginBottom: 'Z' },
          DayMon: { flow: 'x', align: 'center space-between', padding: 'Z 0', borderBottom: '1px solid inkBorder', Label: { text: '{{ monday | polyglot }}', fontSize: 'Z', color: 'inkSubtle' }, Value: { text: '52', fontSize: 'Z', fontWeight: '600', color: 'inkText' } },
          DayTue: { flow: 'x', align: 'center space-between', padding: 'Z 0', borderBottom: '1px solid inkBorder', Label: { text: '{{ tuesday | polyglot }}', fontSize: 'Z', color: 'inkSubtle' }, Value: { text: '61', fontSize: 'Z', fontWeight: '600', color: 'inkText' } },
          DayWed: { flow: 'x', align: 'center space-between', padding: 'Z 0', borderBottom: '1px solid inkBorder', Label: { text: '{{ wednesday | polyglot }}', fontSize: 'Z', color: 'inkSubtle' }, Value: { text: '58', fontSize: 'Z', fontWeight: '600', color: 'inkText' } },
          DayThu: { flow: 'x', align: 'center space-between', padding: 'Z 0', borderBottom: '1px solid inkBorder', Label: { text: '{{ thursday | polyglot }}', fontSize: 'Z', color: 'inkSubtle' }, Value: { text: '64', fontSize: 'Z', fontWeight: '600', color: 'inkText' } },
          DayFri: { flow: 'x', align: 'center space-between', padding: 'Z 0', borderBottom: '1px solid inkBorder', Label: { text: '{{ friday | polyglot }}', fontSize: 'Z', color: 'inkSubtle' }, Value: { text: '68', fontSize: 'Z', fontWeight: '600', color: 'inkText' } },
          DaySat: { flow: 'x', align: 'center space-between', padding: 'Z 0', Label: { text: '{{ saturday | polyglot }}', fontSize: 'Z', color: 'inkSubtle' }, Value: { text: '39', fontSize: 'Z', fontWeight: '600', color: 'inkText' } }
        }
      },

      // ─── TREATMENT ACCEPTANCE VIEW ───────────────
      TreatmentAcceptanceView: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.reportType === 'acceptance',

        AcceptanceStats: {
          flow: 'x', gap: 'A', flexWrap: 'wrap', '@mobileL': { flow: 'y' },
          CardPresented: { extends: 'ReportCard', state: { title: 'Plans Presented', value: '45', trend: '+8', trendColor: 'green' } },
          CardAccepted: { extends: 'ReportCard', state: { title: 'Accepted', value: '31', trend: '+5', trendColor: 'green' } },
          CardAcceptRate: { extends: 'ReportCard', state: { title: 'Acceptance Rate', value: '68.9%', trend: '+3.2%', trendColor: 'green' } }
        },

        DeclinedSection: {
          flow: 'y', gap: 'Z', padding: 'B', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
          DeclinedTitle: { tag: 'h3', text: '{{ topDeclinedTreatments | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText', marginBottom: 'Z' },

          DecRow1: {
            flow: 'x', align: 'center space-between', padding: 'Z 0', borderBottom: '1px solid inkBorder',
            Info: { flow: 'y', gap: 'X', Name: { text: '{{ implantPlacement | polyglot }}', fontSize: 'Z', color: 'inkText', fontWeight: '500' }, Reason: { text: '{{ costConcerns | polyglot }}', fontSize: 'Y', color: 'inkMuted' } },
            Count: { text: '5 declined', fontSize: 'Z', color: 'red', fontWeight: '600' }
          },
          DecRow2: {
            flow: 'x', align: 'center space-between', padding: 'Z 0', borderBottom: '1px solid inkBorder',
            Info: { flow: 'y', gap: 'X', Name: { text: '{{ ceramicCrown | polyglot }}', fontSize: 'Z', color: 'inkText', fontWeight: '500' }, Reason: { text: '{{ wantsToWait | polyglot }}', fontSize: 'Y', color: 'inkMuted' } },
            Count: { text: '3 declined', fontSize: 'Z', color: 'red', fontWeight: '600' }
          },
          DecRow3: {
            flow: 'x', align: 'center space-between', padding: 'Z 0', borderBottom: '1px solid inkBorder',
            Info: { flow: 'y', gap: 'X', Name: { text: '{{ orthodontics | polyglot }}', fontSize: 'Z', color: 'inkText', fontWeight: '500' }, Reason: { text: '{{ insuranceNotCovering | polyglot }}', fontSize: 'Y', color: 'inkMuted' } },
            Count: { text: '3 declined', fontSize: 'Z', color: 'red', fontWeight: '600' }
          },
          DecRow4: {
            flow: 'x', align: 'center space-between', padding: 'Z 0', borderBottom: '1px solid inkBorder',
            Info: { flow: 'y', gap: 'X', Name: { text: '{{ whitening | polyglot }}', fontSize: 'Z', color: 'inkText', fontWeight: '500' }, Reason: { text: '{{ notAPriority | polyglot }}', fontSize: 'Y', color: 'inkMuted' } },
            Count: { text: '2 declined', fontSize: 'Z', color: 'amber', fontWeight: '600' }
          },
          DecRow5: {
            flow: 'x', align: 'center space-between', padding: 'Z 0',
            Info: { flow: 'y', gap: 'X', Name: { text: '{{ rootCanal | polyglot }}', fontSize: 'Z', color: 'inkText', fontWeight: '500' }, Reason: { text: '{{ seekingSecondOpinion | polyglot }}', fontSize: 'Y', color: 'inkMuted' } },
            Count: { text: '1 declined', fontSize: 'Z', color: 'amber', fontWeight: '600' }
          }
        }
      },

      // ─── RECALL VIEW ─────────────────────────────
      RecallView: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.reportType === 'recall',

        RecallChart: { extends: 'RecallEffectivenessChart' },

        RecallStats: {
          flow: 'x', gap: 'A', flexWrap: 'wrap', '@mobileL': { flow: 'y' },
          CardDue: { extends: 'ReportCard', state: { title: 'Due This Month', value: '120', trend: '+15', trendColor: 'amber' } },
          CardScheduled: { extends: 'ReportCard', state: { title: 'Scheduled', value: '78', trend: '+12', trendColor: 'green' } },
          CardOverdue: { extends: 'ReportCard', state: { title: 'Overdue', value: '42', trend: '-8', trendColor: 'green' } },
          CardReactivation: { extends: 'ReportCard', state: { title: 'Reactivation Rate', value: '65%', trend: '+4%', trendColor: 'green' } }
        }
      }
    },
    MobileTabBar: {}
  }
}
